<div class="mat-headline-5 title">Enabled services</div>
<div class="onsip-grid-placement-shelf">
  <div class="e911-service">
    <div class="mat-body-1 m-b-12">E911</div>
    <div class="mat-body-2 m-b-20">
      {{
        (e911Enabled | async)
          ? ("ONSIP_I18N.ENABLED" | translate)
          : ("ONSIP_I18N.DISABLED" | translate)
      }}
    </div>
    <button mat-stroked-button color="primary" class="e911-btn" [routerLink]="views.E911_TABLE">
      View E911
    </button>
  </div>
  <div class="blf-service">
    <div class="mat-body-1 m-b-12">Busy lamp field</div>
    <div class="mat-body-2 m-b-20">
      {{
        (blfEnabled | async)
          ? ("ONSIP_I18N.ENABLED" | translate)
          : ("ONSIP_I18N.DISABLED" | translate)
      }}
    </div>
    <button mat-stroked-button color="primary" class="busy-lamp-btn" [routerLink]="views.PHONES">
      View phones
    </button>
  </div>
  <div class="moh-service">
    <div class="mat-body-1 m-b-12">Music on hold</div>
    <div class="mat-body-2 m-b-20">
      {{
        (mohEnabled | async)
          ? ("ONSIP_I18N.ENABLED" | translate)
          : ("ONSIP_I18N.DISABLED" | translate)
      }}
    </div>
    <button
      mat-stroked-button
      color="primary"
      class="moh-btn"
      [routerLink]="views.ADMIN_MUSIC_ON_HOLD"
    >
      View music on hold
    </button>
  </div>
  <div class="extended-dialing">
    <div class="mat-body-1 m-b-12">International Dialing</div>
    <div class="mat-body-2 m-b-20">
      {{
        (extendedDialing | async)
          ? ("ONSIP_I18N.ENABLED" | translate)
          : ("ONSIP_I18N.DISABLED" | translate)
      }}
    </div>

    @if ((extendedDialing | async)) {
    <ul>
      <li>Daily limit: ${{ (accountInfo$ | async)?.internationalDailyLimitReset }}</li>
      <li>Today's remaining: ${{ (accountInfo$ | async)?.internationalDailyLimit }}</li>
      <li>To modify the daily call allowance, please contact <b>Support&#64;onsip.com</b></li>
    </ul>
    } @else {
    <a
      mat-stroked-button
      color="primary"
      [href]="internationalDialingUrl"
      target="_blank"
      class="international-btn"
    >
      {{ "ONSIP_I18N.DOWNLOAD_FORM" | translate }}
    </a>
    }
  </div>
</div>
<div class="mat-body-2 contact-support">
  {{ "ONSIP_I18N.NEED_HELP_CONTACT_OUR" | translate }}
  <a class="support-link" [routerLink]="[views.CONTACT_SUPPORT]">
    {{ "ONSIP_I18N.SUPPORT_TEAM" | translate }}
  </a>
</div>
